import React from 'react';  
import { NavLink } from 'react-router-dom';

const Footer = () => (
    <div className="page__footer">
        <section className="footer page__footer-wrapper">
            <div className="social social_footer">
                <NavLink className="social__link social__link_footer social__link_v-footer" target="_blank" to={'https://vk.com/rt_russian'} />
                <NavLink className="social__link social__link_footer social__link_f-footer" target="_blank" to={'https://www.facebook.com/RTRussian'} />
                <NavLink className="social__link social__link_footer social__link_t-footer" target="_blank" to={'https://twitter.com/RT_russian'} />
                <NavLink className="social__link social__link_footer social__link_y-footer" target="_blank" to={'https://www.youtube.com/user/rtrussian'} />
                <NavLink className="social__link social__link_footer social__link_g-footer" target="_blank" to={'https://plus.google.com/+rtrussian'} />
            </div>
            <nav className="nav nav_footer">
                <ul className="nav__list nav__list_footer">
                    <li className="nav__item nav__item_footer">
                        <NavLink className="nav__link nav__link_footer" to={'/olympic2018/medalnyj-zachet-olimpiada-2018'}>Медальный зачет</NavLink>
                    </li>
                    <li className="nav__item nav__item_footer">
                        <NavLink className="nav__link nav__link_footer" to={'/olympic2018/kalendar-olimpiada-2018'}>Расписание</NavLink>
                    </li>
                    <li className="nav__item nav__item_footer">
                        <NavLink className="nav__link nav__link_footer" to={'/olympic2018/materials/'}>Материалы</NavLink>
                    </li>
                </ul>
            </nav>
            <div className="copyright">
                <div className="copyright__text">© Автономная некоммерческая организация «ТВ-Новости»,</div>
                <div className="copyright__text">2005—2018. Все права защищены.</div>
            </div>
            <div className="rt">
                <NavLink className="rt__link" target="_blank" to={'/'} />
            </div>
        </section>
    </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx